export * from './delete-query.class';
export * from './get-query.class';
export * from './patch-query.class';
export * from './post-query.class';
export * from './put-query.class';
